module.exports = {
      id: "minus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#minus",
      toString: function () {
        return this.url;
      }
    }